var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Calendar from 'react-datepicker';
import useWindowSize from '../../customHooks/useWindowWidth';
import { CalendarContainer } from './subcomponents';
const defaultAriaNextMonthLabel = 'Press Enter to move to the next month or press Escape key to close the calendar';
const defaultAriaPreviousMonthLabel = 'Press Enter to move to the previous month or press Escape key to close the calendar';
const CalendarWrapper = (_a) => {
    var { className, highlightDateThemeArr = [], isSelectedDateValid, shouldSubmitOnCalendarDateClicked, selectedDate, temporarySelectedDate, setShouldRenderDatePicker, monthsShown, excludeDates, children, chooseDayAriaLabelPrefix, previousMonthButtonLabel = defaultAriaPreviousMonthLabel, nextMonthButtonLabel = defaultAriaNextMonthLabel, dropdownMode, handleSelectedDateChange, startDate, endDate, required, fixedHeight, showMonthYearDropdown = false, showYearDropdown } = _a, props = __rest(_a, ["className", "highlightDateThemeArr", "isSelectedDateValid", "shouldSubmitOnCalendarDateClicked", "selectedDate", "temporarySelectedDate", "setShouldRenderDatePicker", "monthsShown", "excludeDates", "children", "chooseDayAriaLabelPrefix", "previousMonthButtonLabel", "nextMonthButtonLabel", "dropdownMode", "handleSelectedDateChange", "startDate", "endDate", "required", "fixedHeight", "showMonthYearDropdown", "showYearDropdown"]);
    const windowWidth = useWindowSize();
    const datepickerHighlightedDates = highlightDateThemeArr.map((highlightDate, i) => {
        return {
            [`react-datepicker__day--highlighted-${i}`]: highlightDate.dates
        };
    });
    const numberOfMonthsToShow = () => {
        if (showMonthYearDropdown || windowWidth.isLessThanTablet) {
            return 1;
        }
        return monthsShown !== null && monthsShown !== void 0 ? monthsShown : 2;
    };
    const getSelectedDate = () => {
        if (shouldSubmitOnCalendarDateClicked) {
            if (!isSelectedDateValid) {
                return undefined;
            }
            return selectedDate;
        }
        return temporarySelectedDate;
    };
    return (_jsx(CalendarContainer, Object.assign({ className: className, highlightDateThemeArr: highlightDateThemeArr, monthsShown: numberOfMonthsToShow() }, { children: _jsx(Calendar, Object.assign({ inline: true, highlightDates: datepickerHighlightedDates, excludeDates: excludeDates, monthsShown: numberOfMonthsToShow(), selected: getSelectedDate(), chooseDayAriaLabelPrefix: chooseDayAriaLabelPrefix, previousMonthButtonLabel: previousMonthButtonLabel, nextMonthButtonLabel: nextMonthButtonLabel, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onChange: (date) => {
                /*
                 * [Non operational handler]
                 * It is a required property and preffered choice
                 * but doesnt get triggered when the date is clicked/selected same as the current selection
                 * hence used `onSelect` instead
                 */
            }, onSelect: (date) => {
                // onSelect gets triggered after onChange
                handleSelectedDateChange(date);
            }, onBlur: () => setShouldRenderDatePicker(false), minDate: startDate, maxDate: endDate, fixedHeight: fixedHeight, required: required, dropdownMode: dropdownMode !== null && dropdownMode !== void 0 ? dropdownMode : 'select', formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), showMonthYearDropdown: showMonthYearDropdown, showYearDropdown: showYearDropdown, dateFormatCalendar: "MMM yyyy" }, props, { children: React.Children.map(children, (child) => React.cloneElement(child, {
                highlightDateThemeArr,
                selectedDate
            }, null)) })) })));
};
export default CalendarWrapper;
//# sourceMappingURL=Calendar.js.map